// @flow

import * as api from '../../../api/api';

export default function updateCustomAttributionLinks(data: object) {
    return api.put('/v5/marketplace/attributions', data);
}



// WEBPACK FOOTER //
// ./src/view/my-store/api/updateCustomAttributionLinks.js